import _ from 'lodash';
import { createSelector } from 'reselect';

import { WebHook } from '../../containers/applications/applications.types';
import { getRouteParams } from '../../router/router.selectors';
import { Application } from '../../types/entities';

export const getApplications = (state) => {
  return state.applications;
};

export const getSelectedApplication = createSelector(
  getApplications,
  getRouteParams,
  (applications: Application[], routeParams): Application => {
    const application = _.find<Application>(applications, {
      id: routeParams.applicationId,
    });

    if (!application) {
      throw new Error('application does not exist');
    }

    return application;
  },
);

export const getSelectedApplicationId = createSelector(
  getSelectedApplication,
  (application: Application): string => application.id,
);

export const getSelectedApplicationName = createSelector(
  getSelectedApplication,
  (application: Application): string => _.get(application, 'name', ''),
);

export const getApplicationWebhooks = createSelector(
  getSelectedApplication,
  (application: Application): WebHook[] => _.get(application, 'webhooks', []),
);
